import {Component} from '@angular/core';

@Component({
    selector: 'blank',
    templateUrl: 'blank.component.html'
})
export class BlankLayoutComponent {
}



// WEBPACK FOOTER //
// /app/src/app/layouts/blank/blank.component.ts